/*
 * Notify-button reliability controller (v5 - proxy approach)
 * ----------------------------------------------------------
 * Context: the "Notify Me When Available" button is injected by the third-party
 * Restock Alerts app. This product page has TWO separate variant forms:
 *   - desktop: radio buttons (.pdp-main__info)
 *   - mobile:  a <select> dropdown (.pdp-main__info--mobile)
 * The app only reacts to the DESKTOP form, and it injects its button there. On
 * mobile the desktop form is hidden, so the app's button is never visible, and
 * picking a variant in the mobile dropdown never tells the app to show it.
 *
 * Two things are needed on mobile:
 *   1) Make the app react to mobile dropdown changes  -> mirror the selection
 *      onto the matching desktop radio and fire its change (the exact path that
 *      already works on desktop). The app then creates/updates its real button.
 *   2) Make that button visible in the mobile layout WITHOUT moving the app's
 *      node (moving it caused a relocation tug-of-war = flashing). Instead we
 *      render a clone ("proxy") in the mobile form and forward its click to the
 *      app's real (hidden) button, so the signup still works and subscribes for
 *      the correct (mirrored) variant.
 *
 * Desktop is left completely untouched - the app's native button works there.
 */
(function () {
  'use strict';

  var NOTIFY_SELECTOR =
    '.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button, .notify_me_button';
  var PROXY_CLASS = 'notify-proxy-button';
  var SECTION_SELECTOR = '.page-content--product';
  var MOBILE_SCOPE = '.pdp-main__info--mobile';
  var DESKTOP_SCOPE = '.pdp-main__info';
  var OOS_RE = /out\s*of\s*stock|sold\s*out|unavailable/i;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }
  function hasOwn(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  ready(function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    var availability = {};
    var dataEl = document.getElementById('VariantAvailabilityData');
    if (dataEl) {
      try { availability = JSON.parse(dataEl.textContent || '{}') || {}; } catch (e) { availability = {}; }
    }

    function isMobile() {
      try { if (window.matchMedia) return window.matchMedia('(max-width: 767px)').matches; } catch (e) {}
      return (window.innerWidth || 9999) <= 767;
    }
    function scopeEl(sel) { return section.querySelector(sel); }
    function mobileScope() { return scopeEl(MOBILE_SCOPE) || section; }
    function desktopScopeEl() { return scopeEl(DESKTOP_SCOPE); }

    function selectedControl(scope) {
      var checked = scope.querySelector('input[name="id"]:checked');
      if (checked) return checked;
      var selects = scope.querySelectorAll('select[name="id"]');
      if (selects.length) { var s = selects[selects.length - 1]; return (s.options && s.options[s.selectedIndex]) || s; }
      return scope.querySelector('input[type="hidden"][name="id"]');
    }
    function selectedId(scope) {
      var c = selectedControl(scope);
      if (!c) return null;
      if (c.value != null && c.value !== '') return c.value;
      if (c.getAttribute) return c.getAttribute('value');
      return null;
    }
    // Tri-state: true = OOS, false = available, null = unknown.
    function selectedOOS(scope) {
      var id = selectedId(scope);
      if (id != null && hasOwn(availability, String(id))) return availability[String(id)] === true ? false : true;
      var c = selectedControl(scope);
      if (c && c.getAttribute) {
        var da = c.getAttribute('data-variant-available');
        if (da === 'false') return true;
        if (da === 'true') return false;
        if (OOS_RE.test((c.textContent || '') + ' ' + (c.getAttribute('label') || ''))) return true;
      }
      return null;
    }

    function realButtons() {
      var all = document.querySelectorAll(NOTIFY_SELECTOR);
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].classList.contains(PROXY_CLASS)) continue; // never treat our proxy as the real button
        out.push(all[i]);
      }
      return out;
    }

    /* ----- mount + proxy ----- */
    function ensureMount(scope) {
      var mount = scope.querySelector('.notify-mount');
      if (!mount) { mount = document.createElement('div'); mount.className = 'notify-mount'; }
      var atc = scope.querySelector('button[name="add"], a.pdp__atc.btn--amazon');
      if (atc && atc.parentNode && !atc.classList.contains('notifyButtonStyle')) {
        if (atc.nextSibling !== mount) atc.parentNode.insertBefore(mount, atc.nextSibling);
        return mount;
      }
      var vw = scope.querySelector('.variant-wrapper, .variant-input-wrap');
      if (vw && vw.parentNode) {
        if (vw.nextSibling !== mount) vw.parentNode.insertBefore(mount, vw.nextSibling);
        return mount;
      }
      if (mount.parentNode !== scope) scope.appendChild(mount);
      return mount;
    }

    function buildProxy(realBtn) {
      // Clone for identical appearance; strip identity + theme add-to-cart classes.
      var proxy = realBtn.cloneNode(true);
      proxy.classList.add(PROXY_CLASS);
      ['pdp__atc', 'js-atc', 'pdp_add_cart'].forEach(function (c) { proxy.classList.remove(c); });
      proxy.removeAttribute('id');
      proxy.setAttribute('type', 'button');
      proxy.style.setProperty('display', 'flex', 'important');
      proxy.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var real = document.querySelector(NOTIFY_SELECTOR + ':not(.' + PROXY_CLASS + ')');
        if (real && typeof real.click === 'function') real.click();
      });
      return proxy;
    }

    function removeProxies() {
      var ps = section.querySelectorAll('.' + PROXY_CLASS);
      for (var i = 0; i < ps.length; i++) if (ps[i].parentNode) ps[i].parentNode.removeChild(ps[i]);
    }

    function manage() {
      if (bodyObserver) bodyObserver.disconnect();
      try {
        // Desktop: the app's native button works in place; never proxy.
        if (!isMobile()) { removeProxies(); return; }

        var reals = realButtons();
        var scope = mobileScope();
        var oos = selectedOOS(scope);

        // Only show the proxy when the app has actually injected its button
        // (i.e. the variant is out of stock) and we are not confidently in-stock.
        if (!reals.length || oos === false) { removeProxies(); return; }

        var mount = ensureMount(scope);
        var proxy = mount.querySelector('.' + PROXY_CLASS);
        if (proxy) return; // already present -> idempotent, nothing to do (no flashing)
        removeProxies(); // clear any stray proxy elsewhere
        mount.appendChild(buildProxy(reals[0]));
      } finally {
        if (bodyObserver) bodyObserver.observe(document.body, { childList: true, subtree: true });
      }
    }

    var manageSoon = debounce(manage, 80);

    /* ----- mirror mobile selection onto the desktop form ----- */
    function mirrorToDesktop(variantId) {
      if (!variantId) return;
      var desktop = desktopScopeEl();
      if (!desktop) return;
      var radio = desktop.querySelector('input[name="id"][value="' + variantId + '"]');
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      var label = (radio.labels && radio.labels[0]) ||
                  (radio.id ? desktop.querySelector('label[for="' + radio.id + '"]') : null);
      try { (label || radio).click(); } catch (e) {}
    }

    /* ----- triggers ----- */
    // Only react to notify-button (or nm-portal) injections, not every DOM change.
    var bodyObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var nodes = m.addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && (n.matches(NOTIFY_SELECTOR) || n.matches('.nm-portal'))) ||
              (n.querySelector && n.querySelector(NOTIFY_SELECTOR))) {
            manageSoon();
            return;
          }
        }
        // Also react when the app removes its button (variant became available).
        if (m.removedNodes && m.removedNodes.length) {
          for (var k = 0; k < m.removedNodes.length; k++) {
            var r = m.removedNodes[k];
            if (r.nodeType === 1 && (r.matches && (r.matches(NOTIFY_SELECTOR) || r.matches('.nm-portal')) ||
                (r.querySelector && r.querySelector(NOTIFY_SELECTOR)))) { manageSoon(); return; }
          }
        }
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    section.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'id') return;
      if (e.target.tagName === 'SELECT' && e.target.closest && e.target.closest(MOBILE_SCOPE)) {
        mirrorToDesktop(e.target.value);
      }
      manageSoon();
    });
    window.addEventListener('resize', debounce(manage, 150));

    manage();
    var retries = 0;
    var poll = setInterval(function () { manage(); if (++retries >= 12) clearInterval(poll); }, 500); // ~6s boot net
    window.addEventListener('load', manage);

    window.__notifyButtonFix = {
      manage: manage,
      mirrorToDesktop: mirrorToDesktop,
      selectedOOS: selectedOOS,
      selectedId: selectedId,
      realButtons: realButtons,
      isMobile: isMobile,
      availability: availability,
      version: 'notify-button-fix v5 (proxy)'
    };
    try { console.log('[notify-button-fix] loaded (v5 proxy)'); } catch (e) {}
  });
})();
